import { ROUTES } from "../../config/routes"

const PM_STEP=ROUTES.PRICING_MATRIX.PRICING_MATRIX_STEP;
export const INDUSTRIES={
        [PM_STEP.BUSINESS_PROFESSIONALS]:"B2B",
        [PM_STEP.HEALTHCARE_AUDIENCE]:"Healthcare",
        [PM_STEP.CONSUMER_AUDIENCE]:"B2C",
        [PM_STEP.GOVERNMENT_EMPLOYEES]:"Government Officials",
        [PM_STEP.HIGH_NET_WORTH_INDIVIDUAL]:"High Net Worth",
}
export const GEOGRAPHIES={
    NORTH_AMERICA:"North America",
    EUROPE:"Europe",
    APAC:"APAC",
    LATAM:"LatAm",
    AFRICA:"Africa",
    MIDDLE_EAST:"Middle East"
}
export const B2B_TITLES={
        MANAGERS_BELOW:"Managers & Below",
        VP_DIRECTOR:"VPs/ Directors",
        C_SUITE:"C-Suite"
}
export const CONSUMER_TITLES={
        GEN_POP:"Gen pop"
}
export const GOVENMENT_TITLES={
        GOVT:"Government Employees"
}
export const HEALTHCARE_TITLES={
        PATIENTS:"Patients",
        PHYSICIANS:"Physicians",
        ALLIED_HCPS:"Allied HCPs"
}
export const HIGH_NET_WORTH_INDIVIDUAL_TITLES={
        HNW_INDIVIDUALS:"HNW Individuals"

}
export const LOI_15_35={
        LT_15:"<15",
        BT_15_25:"15_25",
        BT_25_35:"25_35",
        GT_35:">35"
}
export const LOI_30_90={
        LT_30:"<30",
        BT_30_45:"30_45",
        BT_45_60:"45_60",
        BT_60_90:">35"
}
export const LOI_20_40={
        LT_20:"<20",
        BT_20_30:"20_30",
        BT_30_40:"30_40",
        GT_40:">40"
}
export const  IRLevelData={
        LT_5:"<5%",
        GT_20:">20%",
        BT_5_10:"5% - 10%",
        BT_10_20:"10% - 20%",
        BT_20_40:"20% - 40%",
        BT_40_60:"40% - 60%",
        GT_60:">60%",
}

export const B2BtargetableScreenersData={
        GT_ONE_B:"$1B+ revenue or 1000+ FTEs",
        FVHUNDM_ONEB:"$500M-$1B revenue or 500-1000 FTEs",
        ONEHUNDM_FVHUNM:"$100M-$500M revenue or 250- 500 FTEs",
        TENM_ONEHUNM:"$10M-$100M revenue or 100-250 FTEs",
        LT_TENM:"<$10M revenue or <100 FTEs",
}

export const healthcareTargetableScreenersData={
        //physicians & Allied HCPs
        GENERAL_PHYSICIAN:"General practitioners",
        SPECIALIST:"Specialists",
        LT3_YOE:"< 3 years",
        BT_3_6_YOE:"3 years -6 years",
        BT_6_10_YOE:"6 years- 10 years",
        GT_10_YOE:"10+ years",

        // Patients
        COMMON_DISEASE:"Common Ailments",
        RARE_DISEASE:"Rare Disease",

}
export const highNetWorthIndividualsData={
        // INVESTIBLE ASSETS
        HUNDK_TWOHUNDK:"$100k-$250k",
        TWFIFK_FIVHUNDK:"$250k-$499k",
        FIVHUNDK_ONEM:"$500k-$999k",
        GT_ONEM:"$1MM+",

        // ANNUAL INCOME
        SEVFIVK_HUNDK:"$75k-$100k",
        HUNDK_FIVHUNDK:"$100k-$499k",
        ONEFIFK_TWOFIFK:"$150k-$250k",
        GT_TWOFIFK:"$250k+"
}

export const consumerTargetableScreenersData={
        EMPLOYED:"Employed",
        UNEMPLOYED:"Unemployed",
        SELF_EMPLOYED:"Semi-employed",
        STUDENT:"Student",
        RETIRED:"Retired",
        MILITARY:"Military",
}